import { CommonConstants } from './../utilities/commonConstants';
import { CookieHandlerService } from './../services/cookieHandler.service';
import { Directive, HostListener } from '@angular/core';
import { SharedService } from './../services/sharedService';
import { SessionHandlerService } from '../services/sessionHandler.service';
@Directive({
    selector: '[appReloadEvent]',
})
export class ReloadDirective {
    constructor(
        private _sharedservice: SharedService,
        private _cookieHandler: CookieHandlerService,
        private _sessionHandler: SessionHandlerService
    ) { }
    @HostListener('window:beforeunload') onWindowUnload() {
        const applicationId = this._sessionHandler.GetSession(CommonConstants.CookieKeys.applicationId);

        const applicationIDFromCookie = this._cookieHandler.GetCookie(CommonConstants.CookieKeys.applicationId,
            applicationId) || null;
        if (applicationId && applicationIDFromCookie) {
            this._cookieHandler.DeleteCookies([CommonConstants.CookieKeys.applicationId], applicationId);
        }
        if (applicationId && typeof (applicationId) !== 'object') {
            window.name = applicationId;
        }
    }
    @HostListener('window:hashchange') onhashchange() {
        this._sharedservice.setData('brwoserback', true);
    }
    @HostListener('document:deviceready') ondeviceready() {
        this._sharedservice.setData('brwoserback', true);
    }
    @HostListener('window:popstate', ['$event'])
    popstate(event) {
        console.log(event);
    }
}
